import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import PrimaryButton from 'Components/Button/PrimaryButton';
import TextField from 'Components/forms/text-field/TextField';
import TextInput from 'Components/forms/text-input/TextInput.jsx';
import Button from 'Components/Button/Button';
import './CreateDocumentSidePanel.scss';
import ImagePortal from 'Containers/ImagePortal';
import { uploadDocumentFiletype } from 'Apis/caseDataAPI.js';
import { saveDocumentWithCaseDetails } from 'Apis/imageMatcherApi';
import ResponseBanner from 'Components/cards/ResponseBanner';
import SelectInput from 'Components/forms/select-input';
import moment from 'moment';
import { getUrlSearchParamValue } from 'Utils/urlUtils';

export class CreateDocumentSidePanel extends Component {

  constructor(props) {
    super(props);

    this.state = {
      documentFiletypeList: [],
      passFile: [],
      disableSaveButton: false,
      selectedFileLabel: null,
      fileName: '',
      showSmallSizeBanner: false,
      isWarningBanner: false,
      cancelButtonText: 'Cancel',
      isSubmitButtonClicked: false,
      isCancelWarning: false,
      isSuccess: false,
      showErrorBanner: false
    };

    this.attachBindings();
  }

  attachBindings() {

    this.uploadDocumentFiletype = this.uploadDocumentFiletype.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.cancelResponseBanner = this.cancelResponseBanner.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.showWarningBanner = this.showWarningBanner.bind(this);
    this.onTitleInputChange = this.onTitleInputChange.bind(this);
    this.gotoCaseLandingPage = this.gotoCaseLandingPage.bind(this);
    this.showSuccessBanner = this.showSuccessBanner.bind(this);
    this.saveDocumentWithCase = this.saveDocumentWithCase.bind(this);
  }

  componentWillMount() {
    this.uploadDocumentFiletype();
    this.setState({
      passFile: this.props.uploadFileList
    });
  }

  componentWillReceiveProps(nextProps) {

   let caseStageDetail = this.getCaseStageDetail(nextProps.caseLandingDetails);
    let caseStageId = caseStageDetail !== undefined && caseStageDetail !== null ? caseStageDetail.caseStageId : null;
    let fileNameInitial = "CD_InternalDocument_" + this.props.caseNumber + "_" + caseStageId + "_" + moment(new Date()).format("YYYYMMDDHHmmss");
    if ((this.state.fileName == fileNameInitial || this.state.fileName == '') && caseStageId != null) {
      this.setState({
        fileName: fileNameInitial
      });
    }
    if (JSON.stringify(nextProps.uploadFileList) !== JSON.stringify(this.props.uploadFileList)) {
      this.setState({
        passFile: nextProps.uploadFileList,

      });
    }
  }
  
  getCaseStageDetail = (caseLandingDetails) => {
    if (caseLandingDetails !== null && caseLandingDetails.activeCaseStageDetail) {
      return caseLandingDetails.activeCaseStageDetail;
    } else if (caseLandingDetails !== null && caseLandingDetails.caseStageDetail) {
      return caseLandingDetails.caseStageDetail;
    } else {
      return null;
    }
  };
  cancelResponseBanner = () => {
    document.getElementById('1_btn_clear') && document.getElementById('1_btn_clear').blur();
    this.setState({
      isCancelWarning: true,
    });
  }

  closeBanner() {
    this.setState({
      isError: false,
      isCancelWarning: false,
      showErrorBanner: false,
      showSmallSizeBanner: false,
      isWarningBanner: false,
    });
  }

  showSuccessBanner() {
    const successMsg1 = "The document"
    const successMsg2 = " has been saved successfully.";
    const descriptionHtml = (
      <div>
        {successMsg1}&nbsp;
        <b style={{ wordBreak: 'break-word' }}>
          {this.state.fileName}
        </b>{successMsg2}

      </div>
    );
    return (
      <div>
        {this.state.isSuccess && (
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Success"
              description={descriptionHtml}
              type="success"
              successOnly={true}
              primaryButtonText="OPEN CASE DETAILS"
              onClose={this.gotoCaseLandingPage}
              primaryButtonAction={this.gotoCaseLandingPage}
            />
          </ImagePortal>
        )}
      </div>
    );
  }
  showWarningBanner() {
    return (
      <div>
        {this.state.isCancelWarning &&
        <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            description="You will lose all progress you have made."
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Are you Sure you Want to Cancel?"
            description=""
            type="warning"
            onClose={this.closeBanner}
            cancelButtonText="DO NOT CANCEL"
            secondaryButtonAction={this.closeBanner}
            primaryButtonText="YES, PLEASE CANCEL"
            primaryButtonAction={this.gotoCaseLandingPage}
          />
          </ImagePortal>}
        {this.state.isWarningBanner &&
          <ImagePortal>
            <ResponseBanner
              description="Please add details in the document editor canvas before saving the document."
              descriptionStyle={{ color: '#ec9a2f', paddingTop: '10px' }}
              type="warning"
              bannerPosition="smallSizeBanner"
              noActions
              onClose={this.closeBanner}
            />
          </ImagePortal>
        }

        { this.state.showSmallSizeBanner &&
          <ImagePortal>
            <ResponseBanner
              description="You've nearly reached the file size limit. Please keep below 10 MB."
              descriptionStyle={{ color: '#ec9a2f', paddingTop: '10px' }}
              type="warning"
              bannerPosition="smallSizeBanner"
              noActions
              onClose={this.closeBanner}
            />
          </ImagePortal>
        }

      </div>
    );
  }



  uploadDocumentFiletype() {
    uploadDocumentFiletype()
      .then((apiResponse) => {
        this.setState({
          documentFiletypeList: apiResponse.data,
        });
      })
      .catch((error) => {
        this.setState({
          documentFiletypeList: [],
        });
      });
  }

  onSelectionChange = (value) => {
    let selectedDoc = this.state.documentFiletypeList.find(element => element.value === value);
    if (selectedDoc) {
      this.setState({
        selectedFileLabel: selectedDoc,
      });
    }
  }

  onTitleInputChange = (event) => {
    let value = event.target.value;
    const regex = /^[0-9a-zA-Z\-_]{0,100}$/;
    if (value.match(regex)) {
      this.setState({
        fileName: value,
      });
    }
  }

  gotoCaseLandingPage() {
    let baseQueueSelection = getUrlSearchParamValue(this.props.location.search, 'selectedBaseQueueItem');
    let subQueueSelection = getUrlSearchParamValue(this.props.location.search, 'subQueueSelection');
    this.props.history.push(`/caselanding/${this.props.caseNumber}?selectedBaseQueueItem=${baseQueueSelection}&subQueueSelection=${subQueueSelection}`);

  }

  saveDocumentWithCase(fileName, documentType) {
    let responseDetails = {};
    let caseDetail = this.props.caseLandingDetails !== null ? this.props.caseLandingDetails.caseDetail : null;
    let caseStageDetail = this.getCaseStageDetail(this.props.caseLandingDetails);
    if (this.props.content === null || this.props.content === '' || this.props.content == '<p><br></p>') {
      this.setState({
        isWarningBanner: true,
      });
    } else {
      this.setState({
        isWarningBanner: false,
      });
    }
    if (documentType !== null && fileName !== ''
      && caseStageDetail !== null && caseStageDetail.caseStageId !== null
      && caseStageDetail.cardBrandCode !== null && caseDetail !== null && caseDetail.merchantRegionCode !== null) {
      if (this.props.content !== null && this.props.content !== '' && this.props.content !== '<p><br></p>') {
        this.setState({
          disableSaveButton: true,
        });
        let fileContentHtml = '<html><body>' + this.props.content + '</body></html>';

        responseDetails.caseNumber = this.props.caseNumber;
        responseDetails.fileName = fileName;
        responseDetails.documentType = documentType.value;
        responseDetails.documentTypeId = documentType.id;
        responseDetails.htmlInput = fileContentHtml;
        responseDetails.caseStageId = caseStageDetail.caseStageId;
        responseDetails.cardBrandCode = caseStageDetail.cardBrandCode;
        responseDetails.regionCode = caseDetail.merchantRegionCode;

        return saveDocumentWithCaseDetails(responseDetails).then((res) => {
          if (res == 'FileSize Exceeded' || res === 413) {
            this.setState({
              disableSaveButton: false,
              showSmallSizeBanner: true,
            }
            );
          }
          else if (res.status.statusCode == 2000 || res.status.statusCode == 200) {
            this.setState({
              disableSaveButton: false,
              isSuccess: true,
            }
            );
          }
        }).catch((error) => {
          console.log('Error occured while creating the documents', error);
          this.setState({
            showErrorBanner: true,
          });
        });

      }
    }
    else {
      console.log('Error:This case is not valid!! Please try another case');
      this.setState({
        showErrorBanner: true,
      });
    }
  }

  render() {
    return (
      <div className='sidePanel'>
        {this.showWarningBanner()}
        {this.showSuccessBanner()}
        {this.state.showErrorBanner && (
          <ImagePortal>
          <ResponseBanner
            title="Error !"
            description="Error"
            type="danger"
            primaryButtonAction={this.closeBanner}
            cancelButtonText="CANCEL"
            onClose={this.closeBanner}
          />
          </ImagePortal>
        )}
        <div className="createDocumentLabel"  >Create Document</div>
        <div className="border"></div>
        <div className="innerPanel" id='CreateDocument'>
          <div className='description'>
            Please use the editor to the left to create your document.
            Then enter the Filename and select a File Label from the drop down below.
            Every document will be 8.5” x 11”.
        </div>
          <div>
            <TextField
              labelClass="fileLabel error-asterik"
              htmlFor="file-label"
              labelContent={'Filename'}
            >
              <TextInput
                name="file-label"
                placeholder=""
                onChange={this.onTitleInputChange}
                value={this.state.fileName}
                extraStyle={{ fontSize: 12, fontWeight: 500, color: '#7C7C89' }}
              />
            </TextField>
          </div>
          <div style={{ marginBottom: '5px' }}>
            <span className="fileLabel error-asterik">File Label </span>
          </div>
          <SelectInput
            promptText={'Select'}
            id={"selectInput"}
            dataList={this.state.documentFiletypeList.filter(e => e.id !== 16)}
            selectClass={{
              color: '#262aff',
              width: '265px',
              fontWeight: 700,
              fontSize: 14,
            }}
            wrapperClass="select-menu__form reports field-input"
            extraClass="option-box"
            handleSelection={(value) => this.onSelectionChange(value)}
            selectedItem={this.state.selectedFileLabel}
          />
          <div>
            <div style={{ width: "30%", float: 'left' }}>
              <Button
                action={this.cancelResponseBanner}
                extraClass="filter-pane__close-button"
                id={`1_btn_clear`}
                disabled={this.state.disableSaveButton ? true : false}
                style={{ color: '#f4364c', marginTop: '25px' }}
              >
                <strong>{this.state.cancelButtonText}</strong>
              </Button>
            </div>
            <div style={{ width: "70%", float: 'right' }}>
              <PrimaryButton
                action={() => { this.saveDocumentWithCase(this.state.fileName, this.state.selectedFileLabel) }}
                id={'1_submit_btn'}
                extraClass="saveDocumentBtn"
                disabled={(!this.state.selectedFileLabel || !this.state.fileName) || this.state.disableSaveButton ? true : false}
              >
                <strong>Save Document</strong>
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


CreateDocumentSidePanel.propTypes = {
  uploadFileList: PropTypes.array,
  caseNumber: PropTypes.string,
  content: PropTypes.string,
  caseLandingDetails: PropTypes.object,
}



CreateDocumentSidePanel.defaultProps = {
  uploadFileList: [],
  caseNumber: '',
  content: '',
  caseLandingDetails: {},
}

export default withRouter(CreateDocumentSidePanel);